import { render } from "./Blank.vue?vue&type=template&id=0710e229"
import script from "./Blank.vue?vue&type=script&lang=js"
export * from "./Blank.vue?vue&type=script&lang=js"
script.render = render

export default script